module.exports = __webpack_public_path__ + "images/icons/icon-chevron-right-70940e0dbf02a5bcecaf41f4a95e1058.svg";